import { Component, Inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";
import { finalize } from "rxjs";
import { SharedModule } from "@shared/shared.module";
import { SharedService } from "src/app/services/shared.service";
import { ExternalShareService } from "src/app/services/external-share.service";

export interface CopyLinkModalData {
  asset_type: string;
  asset_id: number | string;
  video_id: number | string;
}

@Component({
  selector: "app-copy-link-modal",
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: "./copy-link-modal.component.html",
  styleUrl: "./copy-link-modal.component.scss",
})
export class CopyLinkModalComponent implements OnInit {
  link = "";
  accessCode = "";
  isLoading = false;
  linkCopied = false;
  codeCopied = false;
  hasError = false;

  constructor(
    private sharedService: SharedService,
    private externalShareService: ExternalShareService,
    private modalRef: NzModalRef,
    @Inject(NZ_MODAL_DATA) public data: CopyLinkModalData,
  ) {}

  ngOnInit(): void {
    this.generateLink();
  }

  generateLink(): void {
    this.isLoading = true;
    this.hasError = false;
    this.externalShareService
      .generateLink({
        asset_type: this.data.asset_type,
        asset_id: this.data.asset_id,
        video_id: this.data.video_id,
      })
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res: any) => {
          if (res?.statusCode === 200 || res?.statusCode === 201) {
            this.link = res?.data?.link || "";
            this.accessCode = res?.data?.access_code || "";
          } else {
            this.hasError = true;
            this.sharedService.errorToastNotification(
              res?.message || "Failed to generate share link",
            );
          }
        },
        error: (err) => {
          this.hasError = true;
          this.sharedService.errorToastNotification(
            err?.error?.message || "Failed to generate share link",
          );
        },
      });
  }

  copyLink(): void {
    if (!this.link) return;
    navigator.clipboard.writeText(this.link).then(() => {
      this.linkCopied = true;
      this.sharedService.successToastNotification("Link copied to clipboard");
      setTimeout(() => (this.linkCopied = false), 2000);
    });
  }

  copyCode(): void {
    if (!this.accessCode) return;
    navigator.clipboard.writeText(this.accessCode).then(() => {
      this.codeCopied = true;
      this.sharedService.successToastNotification(
        "Access code copied to clipboard",
      );
      setTimeout(() => (this.codeCopied = false), 2000);
    });
  }

  close(): void {
    this.modalRef.close();
  }
}
